import { ReactElement, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Container } from '@mui/material';
import { PublicBrief as PublicBriefView } from './PublicBrief';
import {
  useAppCrmEventBriefsExternalPartialUpdateMutation,
  useAppCrmEventBriefsExternalRetrieveQuery,
} from '../../store/cabinetApi/generated/crm';
import { skipToken } from '@reduxjs/toolkit/query';

export const PublicBrief = (): ReactElement => {
  const { urlKey } = useParams<{ slug: string; urlKey: string }>();
  
  const { data: briefData, isLoading, error } = useAppCrmEventBriefsExternalRetrieveQuery(urlKey || skipToken);
  const [updateBrief] = useAppCrmEventBriefsExternalPartialUpdateMutation();
  
  const organization = briefData?.organization;
  
  const errorMessage = useMemo(() => {
    if (isLoading || briefData) return null;
    
    // Show generic error message for non-404 errors
    if (error && (!('status' in error) || ('status' in error && error.status !== 404))) {
      return 'Failed to load meeting brief';
    }

    return 'The meeting brief you are looking for does not exist or has been removed.';
  }, [isLoading, briefData, error]);

  const handleNotesUpdate = (content: string) => {
    if (!urlKey) return;
    updateBrief({ urlKey, patchedEventBriefExternal: { notes: JSON.parse(content) } });
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <PublicBriefView
        briefData={briefData}
        loading={isLoading}
        error={errorMessage}
        onNotesUpdate={handleNotesUpdate}
        organization={organization}
      />
    </Container>
  );
};

export default PublicBrief;
